"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _expert = require("@/api/expert/expert");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      isDialog: false,
      minWidth: 300,
      multipleSelection: [],
      tableData: [],
      noAssignTableData: [],
      defaultColumn: [{
        name: "姓名",
        prop: "name",
        isShow: true,
        width: "100"
      }, {
        name: "登录账号",
        prop: "loginName",
        isShow: true,
        width: "150"
      }, {
        name: "邮箱",
        prop: "mail",
        isShow: true,
        width: "150"
      }, {
        name: "手机号",
        prop: "phoneNumber",
        isShow: true,
        width: "150"
      }, {
        name: "成绩",
        prop: "totalScore",
        isShow: true,
        width: "150"
      }, {
        name: "评分状态",
        prop: "status",
        isShow: true,
        width: "150",
        isFormats: true
      }],
      noAssignDefaultColumn: [{
        name: "姓名",
        prop: "name",
        isShow: true,
        width: "100"
      }, {
        name: "登录账号",
        prop: "loginName",
        isShow: true,
        width: "150"
      }, {
        name: "邮箱",
        prop: "email",
        isShow: true,
        width: "150"
      }, {
        name: "手机号",
        prop: "mobilePhone",
        isShow: true,
        width: "150"
      }],
      options: [{
        name: "移出",
        class: "delet",
        option: "deleteById",
        span: 8
      }],
      funBtns: [{
        size: "small",
        click: "deleteById",
        icon: "el-icon-delete",
        name: "批量移除",
        type: "danger"
      }, {
        size: "small",
        click: "dialog",
        icon: "el-icon-circle-plus-outline",
        name: "添加",
        type: "primary"
      }],
      formatters: {
        status: [{
          name: "未评分",
          value: "0"
        }, {
          name: "已评分",
          value: "1"
        }]
      },
      modelData: {
        name: ""
      },
      noAssignModelData: {
        name: ""
      },
      queryGroup: [{
        label: "姓名",
        type: "input",
        model: "name",
        placeholder: "姓名"
      }],
      noAssignQueryGroup: [{
        label: "姓名",
        type: "input",
        model: "name",
        placeholder: "姓名"
      }],
      checkBoxData: [],
      noAssignCheckBoxData: [],
      page: {
        pageNum: 1,
        pageSize: 10
      },
      noAssignPage: {
        pageNum: 1,
        pageSize: 10
      },
      total: null,
      noAssignTotal: null,
      queryValue: ""
    };
  },
  components: {
    ZhjyTable: _zhjyTable.default,
    FunBtn: _funBtn.default,
    ZhjyPagination: _zhjyPagination.default,
    ZhjySerach: _zhjySerach.default
  },
  methods: {
    // 根据作品id获得专家列表
    getList: function getList() {
      var _this = this;
      (0, _expert.ExpertById)({
        name: this.queryValue,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        stageId: this.$route.query.stageId,
        worksId: this.$route.query.worksId
      }).then(function (res) {
        var data = res.data;
        _this.tableData = data.list;
      });
    },
    // 获取阶段下未分配的专家
    getNoMatchExpert: function getNoMatchExpert() {
      var _this2 = this;
      (0, _expert.getNoMatchExpert)({
        name: this.queryValue,
        pageNum: this.noAssignPage.pageNum,
        pageSize: this.noAssignPage.pageSize,
        stageId: this.$route.query.stageId,
        worksId: this.$route.query.worksId
      }).then(function (res) {
        var data = res.data;
        _this2.noAssignTableData = data.list;
        _this2.noAssignTotal = data.total;
      });
    },
    list: function list() {},
    // 搜索
    noAssignSearch: function noAssignSearch(e) {
      this.queryValue = e.name;
      this.getNoMatchExpert();
    },
    noAssignList: function noAssignList() {},
    // 删除、批量删除
    deleteById: function deleteById(row) {
      var _this3 = this;
      var id = [];
      if (!row && this.checkBoxData.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxData.length > 0) {
        id = this.checkBoxData;
      }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _expert.removeExpert)({
          idList: id
        }).then(function () {
          _this3.$message.success("操作成功。");
          _this3.getList();
        });
      }).catch(function () {
        _this3.$message.info("取消删除。");
      });
    },
    // 确认添加
    saveExpert: function saveExpert() {
      var _this4 = this;
      if (this.noAssignCheckBoxData.length > 0) {
        (0, _expert.saveExperts)({
          expertIds: this.noAssignCheckBoxData,
          worksId: this.$route.query.worksId
        }).then(function (res) {
          if (res.code === 2000) {
            _this4.$message.success("添加成功。");
            _this4.isDialog = false;
            _this4.getList();
          }
        });
      } else {
        this.$message.error("请先勾选数据");
      }
    },
    // 添加按钮
    dialog: function dialog() {
      this.getNoMatchExpert();
      this.isDialog = true;
    },
    quitDialog: function quitDialog() {
      this.isDialog = false;
      this.noAssignTableData = [];
    },
    moreDelete: function moreDelete() {},
    search: function search(e) {
      this.queryValue = e.name;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this5 = this;
      this.checkBoxData = [];
      val.forEach(function (item) {
        _this5.checkBoxData.push(item.id);
      });
    },
    noAssignHandleSelectionChange: function noAssignHandleSelectionChange(val) {
      var _this6 = this;
      this.noAssignCheckBoxData = [];
      val.forEach(function (item) {
        _this6.noAssignCheckBoxData.push(item.userId);
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList();
    },
    noAssignHandleCurrentChange: function noAssignHandleCurrentChange(val) {
      this.noAssignPage.pageNum = val;
      this.getNoMatchExpert();
    },
    noAssignHandleSizeChange: function noAssignHandleSizeChange(val) {
      this.noAssignPage.pageSize = val;
      this.getNoMatchExpert();
    }
  },
  created: function created() {
    this.getList();
  }
};